import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagButton = (props: PropsWithChildren<Props>) => {
  const { children, icon, isDisabled, onPress } = props;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Button
      palette="muted"
      leftIcon={icon}
      iconSize={22}
      disabled={isDisabled}
      onPress={onPress}
      style={styles.button}
    >
      <BodyText sizeMatch={['14']}>{children}</BodyText>
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  icon?: ComponentProps<typeof Button>['leftIcon'];
  isDisabled: boolean;
  onPress: () => void;
};
